(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5464],{

/***/ 62373:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile-public/[uid]",
      function () {
        return __webpack_require__(43127);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 43127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(98396);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88767);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9473);
/* harmony import */ var _components_innerLayout_InnerLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66570);
/* harmony import */ var _components_Loader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43369);
/* harmony import */ var _components_public_profile_DesktopView__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55081);
/* harmony import */ var _components_public_profile_MobileView__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88437);
/* harmony import */ var _constants_tabs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28141);
/* harmony import */ var _firebase_user__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32012);
/* harmony import */ var _redux_createSidebarSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18129);
/* harmony import */ var _redux_createTabSlice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89515);

















var ProfilePublic = function() {
    var ref;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var uid = router.query.uid;
    var ref1 = (0,react_query__WEBPACK_IMPORTED_MODULE_4__.useQuery)([
        "userData",
        uid
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!uid || typeof uid !== "string" || uid.length === 0) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        (0,_firebase_user__WEBPACK_IMPORTED_MODULE_11__/* .fetchUserData */ .FQ)(uid)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }), {
        enabled: !!uid && typeof uid === "string" && uid.length > 0
    }), userDataIsLoading = ref1.isLoading, userDataError = ref1.error, userData = ref1.data;
    var ref2 = (0,react_query__WEBPACK_IMPORTED_MODULE_4__.useQuery)([
        "imageData",
        uid
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!uid || typeof uid !== "string" || uid.length === 0) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        (0,_firebase_user__WEBPACK_IMPORTED_MODULE_11__/* .fetchImagesFromUid */ .s0)(uid)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }), {
        enabled: !!uid && typeof uid === "string" && uid.length > 0
    }), imageDataIsLoading = ref2.isLoading, imageDataError = ref2.error, imageData = ref2.data;
    var isMdSize = (0,_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)("(min-width:900px)");
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        userData && dispatch((0,_redux_createSidebarSlice__WEBPACK_IMPORTED_MODULE_12__/* .setSelectedSidebarUser */ .My)(userData));
        dispatch((0,_redux_createTabSlice__WEBPACK_IMPORTED_MODULE_13__/* .setTab */ .IE)(_constants_tabs__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Search */ .Z.Search));
        return function() {
            dispatch((0,_redux_createSidebarSlice__WEBPACK_IMPORTED_MODULE_12__/* .setSelectedSidebarUser */ .My)(null));
        };
    }, [
        userData
    ]);
    if (!userData || !imageData) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {});
    }
    var userCreatedAt = userData.createdAt && new Date(userData.createdAt);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "".concat(userData.firstName, " ").concat(userData.lastName && userData.lastName[0]).concat(userData.tagline ? ": " + userData.tagline : "")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "".concat(userData.firstName, " ").concat(userData.lastName && userData.lastName[0]).concat(userData.tagline ? ": " + userData.tagline : "")
                    }, "title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: userData.bio + " More Pleaze: Private chef experiences where gourmet meets wellness, approachable meets luxury, and all are welcome. Book your chef today!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: (ref = [
                            userData.chefServices,
                            userData.foodPreferences
                        ]) === null || ref === void 0 ? void 0 : ref.join(",")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "".concat(userData.firstName, " ").concat(userData.lastName && userData.lastName)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index, follow"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://app.morepleaze.com/profile-public/".concat(userData.uid)
                    })
                ]
            }),
            isMdSize ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_public_profile_DesktopView__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                userData: userData,
                imageData: imageData
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_public_profile_MobileView__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                userData: userData,
                imageData: imageData
            })
        ]
    });
};
ProfilePublic.getLayout = function getLayout(component) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_innerLayout_InnerLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: component
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ProfilePublic);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4838,1255,8809,9066,89,9912,1440,6570,6746,5839,3090,9774,2888,179], function() { return __webpack_exec__(62373); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);